export default __webpack_public_path__ + "static/media/live_event.a0711022.png";